import React, { useEffect, useState } from "react";
import {
  Flex,
  Heading,
  Box,
  Text,
  Input,
  Button,
  Divider,
  AbsoluteCenter,
} from "@chakra-ui/react";
import SunCalc from "suncalc";

interface ILocation {
  latitude: null | number;
  longitude: null | number;
}

const SolarPage = () => {
  const [latitude, setLatitude] = useState<number>(0);
  const [longitude, setLongitude] = useState<number>(0);
  const [error, setError] = useState<any>(null);

  const detectLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setError(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  };

  useEffect(() => {
    const { azimuth, altitude } = SunCalc.getPosition(
      new Date("2025-01-16T11:40:00"),
      latitude,
      longitude
    );
    console.log({
      direction:
        azimuth * (180 / Math.PI) < 0
          ? 180 + azimuth * (180 / Math.PI)
          : 180 - azimuth * (180 / Math.PI),
      tilt: 90 - altitude * (180 / Math.PI),
    });
  }, [latitude, longitude]);

  return (
    <Flex direction={"column"} alignItems={"center"} gap={6}>
      <Heading>Solar</Heading>

      <Flex gap={"6"} alignItems={"end"}>
        <Box>
          <Text>Latitude</Text>
          <Input
            marginTop={1}
            type={"text"}
            placeholder={"Yearly expenses"}
            value={latitude}
            onChange={(event) => setLatitude(Number(event.target.value))}
          />
        </Box>
        <Box>
          <Text>Latitude</Text>
          <Input
            marginTop={1}
            type={"text"}
            placeholder={"Yearly expenses"}
            value={longitude}
            onChange={(event) => setLongitude(Number(event.target.value))}
          />
        </Box>
        <Button onClick={detectLocation}>Calculate</Button>
      </Flex>

      <Box position="relative" width={"75%"}>
        <Divider />
        <AbsoluteCenter>OR</AbsoluteCenter>
      </Box>

      <Flex>
        <Button onClick={detectLocation}>Detect</Button>
      </Flex>
    </Flex>
  );
};

export default SolarPage;
